export default __webpack_public_path__ + "static/media/money.04692a91.png";